<template>
  <div />
</template>

<script>
import authTypes from "../vuex/auth/auth.authTypes";
import mutateTypes from "../vuex/popupTypes";
import { mapState } from "vuex";

export default {
  computed: mapState({
    isAuthenticated: state => state.auth.isAuthenticated,
    type: state => state.auth.type
  }),
  watch: {
    type() {
      if (this.type === authTypes.LOGIN_FAILED) {
        this.$router.push("/");
      }
      if (this.type === authTypes.LOGIN_SUCCESS) {
        this.$router.push("/dashboard");
      }
    }
  },
  created() {
    this.$store.dispatch("handleAuth");
  }
};
</script>
